import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { logo } from "../assets/svg/svg.js"
import "../components/styles/header.css"
import { getAccountBalance, web3AccountCheck } from '../helper/web3helper.js';
import Cookies from "universal-cookie";
import Profile from './Profile.js';
import balance from "../assets/images/balance.png";
import { getFirstLetterUppercase } from '../helper/object-validation-helper.js';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import config from "../web3/web3Config.json";
import { calender_svg } from "../assets/svg/calender_svg.js";
import { DatePicker, Tooltip } from 'antd';
import moment from 'moment';
import { getOrganizationData } from '../service/api-actions.js';
import { saveOrganizationData } from '../db/at-rest.js';
import DChatLogo from '../assets/svg/DChat-logo.js';
import DFormIogo from '../assets/svg/Dform-logo.js';

const cookies = new Cookies();
const { RangePicker } = DatePicker;

const Header = ({ toggleSidebar }) => {

  const history = useNavigate(); // Get the history object
  const dispatch = useDispatch();
  const [web3Value, setWeb3] = useState(null);
  const [account, setAccount] = useState("");
  const [toolTip, setToolTip] = useState(false)
  const [accountBalance, setAccountBalance] = useState(0);
  const [isProfileOpen, setProfileOpen] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [isApplied, setIsApplied] = useState(false);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const hoverRef = useRef()
  const [filterData, setFilterData] = useState({
    from: '',
    to: '',
    subject: '',
    dateRange: [],
  });
  let profileName = null;
  profileName = useSelector((state) => state.profileName);

  const [user] = useState(cookies.get("userObject"));
  const profileRef = useRef(null);
  const triggerRef = useRef(null);
  const filterRef = useRef(null);
  const triggerfilterRef = useRef(null);
  const triggerAppRef = useRef(null);
  const appRef = useRef(null);
  const [appOpen, setAppOpen] = useState(false);
  // Position for the app-launcher, which is portaled to <body> so it escapes the header's
  // stacking context (the mail-list toolbar otherwise bleeds through it regardless of z-index).
  const [appMenuPos, setAppMenuPos] = useState({ top: 0, right: 16 });
  useEffect(() => {
    if (appOpen && triggerAppRef.current) {
      const r = triggerAppRef.current.getBoundingClientRect();
      setAppMenuPos({ top: r.bottom + 8, right: Math.max(8, window.innerWidth - r.right) });
    }
  }, [appOpen]);
  const [organizationData, setOrganizationData] = useState('');

  const getFilters = useSelector((state) => state.filterObject);
  const searchTerm = useSelector((state) => state.searchTerm);
  useEffect(() => {
    if (Object.keys(getFilters).length > 0) {
      setFilterData({
        from: getFilters.from,
        to: getFilters.to,
        subject: getFilters.subject,
        dateRange: getFilters.dateRange,
      });
    }
  }, [isFilter, getFilters]);

  const handleClickOutside = (event) => {
    if (profileRef.current && !profileRef.current.contains(event.target) && triggerRef.current && !triggerRef.current.contains(event.target)) {
      setProfileOpen(false);
    }
    setToolTip(false)
    const datePickerElement = document.querySelector('.ant-picker-panel-container') ?? false;
    if (filterRef.current && !filterRef.current.contains(event.target) && triggerfilterRef.current && !triggerfilterRef.current.contains(event.target)) {
      if (datePickerElement && !datePickerElement.contains(event.target)) {
        setIsFilter(false);
      } else if (!datePickerElement) {
        setIsFilter(false);
      }
    }
    if (appRef.current && !appRef.current.contains(event.target) && triggerAppRef.current && !triggerAppRef.current.contains(event.target)) {
      setAppOpen(false);
    }
  };

  const disabledDate = (current) => {
    return current && current > moment().startOf('day');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilterData({
      ...filterData,
      [name]: value,
    });
  };

  const handleDateChange = (dates) => {
    setFilterData({
      ...filterData,
      dateRange: dates,
    });
  };
  const triggerFilter = useSelector((state) => state.trigger);
  const handleSubmit = () => {
    dispatch({ type: "FILTER_OBJECT", payload: filterData, value: !triggerFilter });
    // antd's RangePicker reports a cleared range as null, not [], so dateRange stops being an array.
    // Reading .length off it threw right here, before setIsFilter(false) — the filter panel stayed open,
    // the "filter applied" dot never updated, and every further click on Search threw again, so Search
    // looked dead until the user hit Reset.
    if (filterData.from.trim() || filterData.to.trim() || filterData.subject.trim() || filterData.dateRange?.length > 0) {
      setIsApplied(true);
      setToolTip(true)
    } else {
      setToolTip(false)
      setIsApplied(false);
    }
    setIsFilter(false);
  };

  useEffect(() => {

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    web3AccountCheck(setWeb3, setAccount);
  }, []);

  useEffect(() => {
    async function fetchdata() {
      if (account) {

        const availableBalance = await getAccountBalance(web3Value, account);
        setAccountBalance(Number(availableBalance));
      }
    }
    if (web3Value) {
      fetchdata();
    }
  }, [web3Value, account]);

  useEffect(() => {
    const getOrganization = async () => {
      const organizationData = await getOrganizationData(user?.name?.split('@')?.pop(), user?.name);
      if (organizationData?.data?.uuid) {
        dispatch({ type: "ORGANIZATION_DATA", payload: organizationData?.data })
        // Sealed under the dMail DEK at rest (db/at-rest.js). This row holds the user's primaryEmail and
        // their organization/user settings, and it used to be written straight to IndexedDB in the clear —
        // where it now stays forever, because sign-in no longer wipes the database for the same user.
        // saveOrganizationData upserts (it owns the one-row invariant) and never writes plaintext.
        await saveOrganizationData(organizationData?.data);
        setOrganizationData(organizationData?.data?.organizationData);
      }
    }
    getOrganization()
  }, []);

  function handleProfile() {
    setProfileOpen(!isProfileOpen);
  }

  const handleApp = () => {
    setAppOpen(!appOpen)
  }

  function handleSettings(e) {
    history("/settings");
  }
  const handleToolTip = () => {
    if (isApplied) setToolTip(true)
  }

  return (
    <>
      <div ref={profileRef}>
        < Profile handleProfile={handleProfile} isProfileOpen={isProfileOpen} />
      </div>
      <div className='header-common-class'>
        <div className='header-container'>
          <div className="flex items-center">
            {/* <span className='cursor-pointer' onClick={() => {dispatch({ type: "HIDE_SIDE_BAR", payload: !hideSideBar } ); }}>{calender_svg.menu_svg}</span> */}
            <a className="bars cursor-pointer" onClick={toggleSidebar}>{calender_svg.menu_svg}</a>
            <div className={`search-header ${isSearchFocused ? 'search-header-focused' : ''}`}>
              <div className='d-flex align-items-center  gap-2  headerInpParent'>
                <span className='mt-2'>{logo.dmail_search_icon_header}</span>
                {/* Controlled off the store. Uncontrolled, the box could show a query that was no
                    longer applied to the list. */}
                <input
                className='header-input-search'
                  type="text"
                  placeholder='Search for message...'
                  value={searchTerm}
                  onFocus={() => setIsSearchFocused(true)}
                  onBlur={() => setIsSearchFocused(false)}
                  onChange={(e) => {
                    dispatch({ type: "SEARCH_TERM", payload: e.target.value })
                  }}
                />
                {searchTerm && (
                  <span
                    className='cursor-pointer d-flex align-items-center px-1'
                    role="button"
                    aria-label="Clear search"
                    onClick={() => dispatch({ type: "SEARCH_TERM", payload: "" })}
                  >
                    &#10005;
                  </span>
                )}
              </div>
              <div className='search-icon d-flex gap-10 align-items-center justify-content-center user-select-none' onMouseOver={handleToolTip} >
                <span className='cursor-pointer d-flex align-items-center justify-content-center' ref={triggerfilterRef} onClick={() => { setIsFilter(!isFilter) }}>
                  {logo.filter_icon_svg}
                  <Tooltip title="Filter applied!" placement="right" open={toolTip}>
                    {isApplied && <span className='filter-applied'></span>}
                  </Tooltip>
                </span>
              </div>
            </div>

            {isFilter &&
              <div className='filter-section' ref={filterRef}>
                <div className="card">
                  <div className="card-body">
                    <div className="border-bottom d-flex mt-2 gap-10">
                      <span><b>From:</b> </span>
                      <input className="reply-user-input compose" name='from' value={filterData.from}
                        onChange={handleInputChange} />
                    </div>
                    <div className="border-bottom d-flex mt-4 gap-10">
                      <span><b>To:</b> </span>
                      <input className="reply-user-input compose" name='to' value={filterData.to}
                        onChange={handleInputChange} />
                    </div>
                    <div className="border-bottom d-flex mt-4 gap-10">
                      <span><b>Subject:</b> </span>
                      <input className="reply-user-input compose" name='subject' value={filterData.subject}
                        onChange={handleInputChange} />
                    </div>
                    <div className="d-flex mt-4 align-items-center gap-10">
                      <span><b>Date within:</b> </span>
                      <RangePicker
                        className="custom-date-picker"
                        placeholder={['Start Date', 'End Date']}
                        disabledDate={disabledDate}
                        value={filterData.dateRange}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="d-flex mt-4 gap-10 justify-content-end align-items-center">
                      <p className="cursor-pointer text-decoration-none gradient-text m-0" onClick={() => {
                        setFilterData({
                          from: '',
                          to: '',
                          subject: '',
                          dateRange: [],
                        });
                        dispatch({ type: "FILTER_OBJECT", payload: {}, value: !triggerFilter });
                        setIsFilter(false);
                        setToolTip(false)
                        setIsApplied(false);
                      }
                      }>Reset</p>
                      <button className="linear-gradient-btn" onClick={handleSubmit}>Search</button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div className="flex items-center">
            {/* <div className='balance-header'>
              <div className='chain-icon'>   <img src={balance} alt="Web3" /> </div>
              <div className='balance-details'>
                <div className='balance-text'>Balance</div>
                <div className='balance-value'>{accountBalance.toFixed(4)} {config.SYMBOL}</div>
              </div>
            </div> */}
            <div className='settings-header cursor-poiner-common' onClick={handleSettings} >
              {logo.dmail_settings_svg}
            </div>
            <div className='settings-header'>
              <span className='cursor-pointer d-flex' onClick={handleApp} ref={triggerAppRef}>{logo.app_menu}</span>
              {appOpen && createPortal(
                <div className='app-menu' ref={appRef}
                  style={{ position: 'fixed', top: appMenuPos.top, right: appMenuPos.right, left: 'auto', zIndex: 100000 }}>
                  <div className='app-menu-item'>
                    <div className='app-menu-item-icon cursor-pointer d-flex justify-content-start align-items-center' onClick={() => {
                      window.open(config.DCALENDAR_URL, "_blank");
                    }}>
                      <img src='/app/Dcalendar-Black.svg' width={120} alt='dcalender-icon' />
                    </div>
                    <div className='app-menu-item-icon cursor-pointer d-flex justify-content-start align-items-center' onClick={() => {
                      window.open(config.DCONTACT_URL, "_blank");
                    }}>
                      <img src='/app/Dcontacts-Black.svg' width={115} alt='dcontacts-icon' />
                    </div>
                    <div className='app-menu-item-icon cursor-pointer d-flex justify-content-start align-items-center fw-semibold' onClick={() => {
                      window.open(config.DFORM_URL, "_blank");
                    }}>
                      <DFormIogo /> DForm
                    </div>
                    <div className='app-menu-item-icon cursor-pointer d-flex justify-content-start align-items-center fw-semibold gap-6px'onClick={() => {
                      window.open(config.DCHAT_URL, "_blank");
                    }}>
                      <DChatLogo /> DChat
                    </div>
                  </div>
                </div>,
                document.body
              )}
            </div>
            <div>

              <div className='user-profile-header' ref={triggerRef} onClick={handleProfile} >
                <div className='user-profile-header gap-10'>
                  <div className='user-profile-header gap-10'>
                    {organizationData?.accountSettings && organizationData?.accountSettings?.defaultLogo === false &&
                      <img src={organizationData?.accountSettings?.imageUrl} alt='org_logo' />
                    }
                    <div className="user-profile-pic cursor-pointer">{getFirstLetterUppercase(user.name.split("@")[0])}</div>
                  </div>
                  <div className='user-profile-name' >
                    <div className='user-profile-username'>  {(profileName?.firstName && profileName?.lastName) ? `${profileName?.firstName} ${profileName?.lastName}` : (profileName?.firstName || profileName?.lastName || user?.name?.split("@")?.[0])}</div>
                    <div className='user-profile-useremail'>{user.name}</div>
                  </div>
                </div>
                <div className='user-profile-arrow cursor-poiner-common' >{logo.dmail_arrow_down_svg}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header
